import * as React from 'react';
import { Box, TableRow, Table, TableHead, TableCell, TableBody, TableSortLabel, useTheme } from '@mui/material';
import EmptyState from 'src/frontend-common/components/EmptyState';
import { CompanyDetail, GetCompaniesSort } from 'src/dto/Company';
import { CompanyCells } from 'src/pages/Companies/components/CompaniesList/CompanyCells';
import Row from 'src/frontend-common/components/Row';
import { TableWrapper } from 'src/style/common';

interface Props {
  companies: CompanyDetail[];
  sort: GetCompaniesSort;
  setSort: (s: GetCompaniesSort) => void;
  isShowDeleted?: boolean;
}

export const CompaniesList: React.FC<Props> = (props) => {
  const noCompanies = props.companies.length === 0;
  const theme = useTheme();

  if (noCompanies) {
    return (
      <Box style={{ position: 'relative' }}>
        <EmptyState style={{ width: '100%', padding: '80px 20px' }} />
      </Box>
    );
  }

  return (
    <TableWrapper data-cy="companies-list">
      <Table>
        <TableHead data-cy="companies-list">
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>
              <Row>
                <TableSortLabel
                  sx={{ color: `${theme.palette.text.primary} !important` }}
                  direction={props.sort === 'dateDesc' ? 'desc' : props.sort === 'dateAsc' ? 'asc' : undefined}
                  onClick={() => props.setSort(props.sort === 'dateDesc' ? 'dateAsc' : 'dateDesc')}
                >
                  Creation date
                </TableSortLabel>
              </Row>
            </TableCell>
            {props.isShowDeleted && <TableCell>Deletion details</TableCell>}
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.companies.map((c) => (
            <TableRow key={c.id} hover>
              <CompanyCells company={c} isShowDeleted={props.isShowDeleted} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );
};
